/**
 * index
 *
 * @author fukui
 */
import flexible from './lib-flexible';

export default flexible;
